import { ChangeEvent, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { IRootState } from '../../../../../redux/types'
import { IOffer } from '../../models/offers'
import { getRoles } from '../../../../../redux/actions/roles'
import { getLanguages } from '../../../../../redux/actions/languages'
import { getCountries, getFilteredCountries } from '../../../../../redux/actions/countries'
import { formValidator, resetFormValidator } from '../../../../../redux/actions/validator'
import { createOffer, toggleFormOffer, updateOffer } from '../../../../../redux/actions/offers'

export const useOffersModal = () => {
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { offer_selected, showForm } = useSelector((state: IRootState) => state.offer)
  const { roles } = useSelector((state: IRootState) => state.role)
  const { languages } = useSelector((state: IRootState) => state.language)
  const { isValidForm, errorForm, errorTab, msgForm } = useSelector((state: IRootState) => state.validator)

  const [offerState, setOfferState] = useState<IOffer>({
    id: null,
    brand: null,
    line: null,
    country: null,
    language: null,
    role: [],
    title: '',
    filesNames: [],
    date_ini: null,
    date_end: null,
    type: 0,
    status: 0,
    visibility: 0
  })

  const [currentTab, setCurrentTab] = useState(0)

  useEffect(() => {
    if (roles.length === 0) {
      dispatch(getRoles())
    }
    if (languages.length === 0) {
      dispatch(getLanguages())
    }
  }, [dispatch, roles.length, languages.length])

  useEffect(() => {
    if (offer_selected != null) {
      setOfferState({
        id: offer_selected.id,
        brand: offer_selected.brand,
        line: offer_selected.line,
        country: offer_selected.country,
        language: offer_selected.language,
        role: offer_selected.role,
        title: offer_selected.title,
        filesNames: [
          ...offer_selected.images.map((file: any) => {
            return { name: file.file_name, type: file.type }
          }),
          ...offer_selected.support_files.map((file: any) => {
            return { name: file.file_name, type: file.type }
          })
        ],
        date_ini: offer_selected.date_ini != null ? dayjs(offer_selected.date_ini) : null,
        date_end: offer_selected.date_end != null ? dayjs(offer_selected.date_end) : null,
        type: offer_selected.type,
        status: offer_selected.status,
        visibility: offer_selected.visibility
      })
    }
  }, [offer_selected])

  useEffect(() => {
    if (authUser != null) {
      if (authUser.role_id === 1) dispatch(getCountries())
      else dispatch(getFilteredCountries())
    }
  }, [authUser, dispatch])

  useEffect(() => {
    if (isValidForm) {
      let tmpData: any = offerState
      tmpData.date_ini = offerState.date_ini !== null ? dayjs(offerState.date_ini).format('YYYY-MM-DD HH:mm:ss') : null
      tmpData.date_end = offerState.date_end !== null ? dayjs(offerState.date_end).format('YYYY-MM-DD HH:mm:ss') : null
      dispatch(resetFormValidator())

      if (offerState.id == null) {
        dispatch(createOffer(tmpData))
      } else {
        dispatch(updateOffer(tmpData))
      }

      dispatch(toggleFormOffer())
    }
  }, [isValidForm, offerState, dispatch])

  const handleChangeTab = (_event: ChangeEvent<unknown>, newValue: number) => {
    setCurrentTab(newValue)
  }

  const handleSubmit = () => {
    if (offerState.id == null) {
      dispatch(
        formValidator({
          title: [offerState.title, 'required|max:250|min:2'],
          brand: [offerState.brand, 'required'],
          countries: [offerState.country, 'required', 'general'],
          languages: [offerState.language, 'required', 'general'],
          role: [offerState.role, 'notempty', 'general'],
          filesNames: [offerState.filesNames, 'notempty', 'general']
        })
      )
    } else {
      dispatch(
        formValidator({
          title: [offerState.title, 'required|max:250|min:2'],
          brand: [offerState.brand, 'required'],
          countries: [offerState.country, 'required', 'general'],
          languages: [offerState.language, 'required', 'general'],
          role: [offerState.role, 'notempty', 'general']
        })
      )
    }
  }

  const handleCloseModal = () => {
    dispatch(toggleFormOffer())
  }

  const hasDialogActionsError = !isValidForm && Object.keys(msgForm).length > 0

  return {
    showForm,
    offerState,
    setOfferState,
    currentTab,
    errorForm,
    errorTab,
    msgForm,
    isValidForm,
    roles,
    languages,
    handleChangeTab,
    handleSubmit,
    handleCloseModal,
    hasDialogActionsError
  }
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}
